/**
 * TextField Component
 * 
 * Reusable form input component that handles text, email, and textarea types
 * with consistent styling and validation support.
 */
import React from 'react';

const TextField = ({
  label,
  name,
  value,
  onChange,
  placeholder = '',
  required = false,
  type = 'text',
  rows = 2,
  className = ''
}) => {
  const id = `field-${name}`;
  const isTextarea = type === 'textarea';

  return (
    <div className={className}>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      
      {isTextarea ? (
        <textarea
          id={id}
          name={name}
          value={value || ''}
          onChange={onChange}
          rows={rows}
          required={required}
          className="w-full p-2 border border-gray-300 rounded-md"
          placeholder={placeholder}
        ></textarea>
      ) : (
        <input
          type={type}
          id={id}
          name={name}
          value={value || ''}
          onChange={onChange}
          required={required}
          className="w-full p-2 border border-gray-300 rounded-md"
          placeholder={placeholder}
        />
      )}
    </div>
  );
};

export default TextField; 